import {parsePaintedWall, wallIntersectsSweep, type PaintedWallGeometry, type WallPoint} from './painted-wall-geometry';

/** Only audited opaque spell identities; Wind/Rift must not become visual barriers. */
export function paintedWallOpaqueGeometries(statuses: readonly Record<string, unknown>[]): PaintedWallGeometry[] {
  return statuses.flatMap(status => {
    if (Number(status.status_deleted) || Number(status.status_paused) || Number(status.status_campaign_paused)
      || ['year','month','day','hour','minute','second'].some(part=>Number(status[`status_paused_campaign_${part}`]))) return [];
    if (!['D7049DF3-2800-E170-B3B3-E5AB57CD7C9F', 'E10D3A9E-D524-C1E3-7745-99D69403CE63', 'DA53F59D-2714-47C7-A973-C68516B817D2', 'FB72381D-4541-0398-CD0B-9F6A7F997D98', 'FC95B5FB-B47D-7848-F956-06663487666C'].includes(String(status.status_origin_id || status.status_item_id || '').toUpperCase())
      || !Number(status.status_aoe_source)) return [];
    const geometry=parsePaintedWall(status.status_aoe_geometry);
    return geometry?[geometry]:[];
  });
}

export function paintedWallObscuresRay(walls: readonly PaintedWallGeometry[], from: WallPoint, to: WallPoint): boolean {
  return walls.some(wall=>wallIntersectsSweep(wall,from,to,0,0));
}
